<div class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
  <form [formGroup]="formGroup" novalidate>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtInvoicevalue}}" type="number" formControlName="InvoiceValue" [(ngModel)]="parent.order.P_TotalAmount" required (ngModelChange)="calculateVal()">
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtCOD}}" type="number" formControlName="CashOnDelivery" [(ngModel)]="codEr" required (ngModelChange)="calculateVal()">
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_CODCost}}" type="number" 
              formControlName="CashOnDeliveryCostper" 
              [(ngModel)]="parent.order.F_CODCost" required (ngModelChange)="calculateVal()" 
              (keypress)="appService.onlyPositiveNumber($event)" 
              min="0.00" max="100.00">
              <mat-error *ngIf="formGroupErrors.CashOnDeliveryCostper.required">
                  {{translations.msgPleaseEnterCODCost}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.CashOnDeliveryCostper.min">{{translations.msgInvalidCOD}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CashOnDeliveryCostper.max">{{translations.msgInvalidCOD}}</mat-error>

              <mat-error *ngIf="formGroupErrors.CashOnDeliveryCostper.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_CODCostVal}}" type="number" formControlName="CashOnDeliveryCosts" [(ngModel)]="codVal" [style.color]="codVal.toString().indexOf('-') > -1 ? 'red' : ''" readonly>
              <mat-error *ngIf="formGroupErrors.CashOnDeliveryCosts.min">{{translations.msgInvalidCODCost}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CashOnDeliveryCosts.max">{{translations.msgInvalidCODCost}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_DeliverCost}}" type="number" 
              formControlName="DeliveryCosts" (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99"
              [(ngModel)]="parent.order.F_DeliverCost" required (ngModelChange)="calculateVal()" >
              <mat-error *ngIf="formGroupErrors.DeliveryCosts.required">
                  {{translations.msgPleaseEnterDeliveryCost}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.DeliveryCosts.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.DeliveryCosts.max">{{translations.msgInvalidDeliveryCost}}</mat-error>
              <mat-error *ngIf="formGroupErrors.DeliveryCosts.min">{{translations.msgInvalidDeliveryCost}}</mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_CustomeCost}}" type="number" 
              formControlName="CustomsFees" (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99"
              [(ngModel)]="parent.order.F_CustomeCost" (ngModelChange)="calculateVal()">
              <mat-error *ngIf="formGroupErrors.CustomsFees.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.CustomsFees.max">{{translations.msgInvalidCustomCost}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CustomsFees.min">{{translations.msgInvalidCustomCost}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_VAT}}" type="number" formControlName="VATSwitzerlandPer" 
              [(ngModel)]="parent.order.F_VAT" required (ngModelChange)="calculateVal()" (keypress)="appService.onlyPositiveNumber($event)" min="0.00" max="100.00">
              <mat-error *ngIf="formGroupErrors.VATSwitzerlandPer.required">
                  {{translations.msgPleaseEnterVAT}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.VATSwitzerlandPer.min">{{translations.msgInvalidVAT}}</mat-error>
              <mat-error *ngIf="formGroupErrors.VATSwitzerlandPer.max">{{translations.msgInvalidVAT}}</mat-error>
              <mat-error *ngIf="formGroupErrors.VATSwitzerlandPer.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_VATVal}}" type="number" formControlName="VATSwitzerland" [(ngModel)]="vatSwisVal" [style.color]="vatSwisVal.toString().indexOf('-') > -1 ? 'red' : ''" readonly>
              <mat-error *ngIf="formGroupErrors.VATSwitzerland.min">{{translations.msgInvalidVATVal}}</mat-error>
              <mat-error *ngIf="formGroupErrors.VATSwitzerland.max">{{translations.msgInvalidVATVal}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="33">
              <input matInput placeholder="{{translations.txtTransportinvoice}}" type="number" formControlName="TransportInvoice" [(ngModel)]="tranInvoiceVal" [style.color]="tranInvoiceVal.toString().indexOf('-') > -1 ? 'red' : ''" readonly>
              <mat-error *ngIf="formGroupErrors.TransportInvoice.min">{{translations.msgInvalidTransportInvoice}}</mat-error>
              <mat-error *ngIf="formGroupErrors.TransportInvoice.max">{{translations.msgInvalidTransportInvoice}}</mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="34">
              <input matInput placeholder="{{translations.txtF_STRCost}}" type="number" formControlName="CostsSTR" 
              [(ngModel)]="parent.order.F_STRCost" (ngModelChange)="calculateVal()" (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99">
              <mat-error *ngIf="formGroupErrors.CostsSTR.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.CostsSTR.max">{{translations.msgInvalidCostSTR}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CostsSTR.min">{{translations.msgInvalidCostSTR}}</mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="33">
              <input matInput placeholder="{{translations.txtF_PFCost}}" type="number" formControlName="CostsPF" 
              [(ngModel)]="parent.order.F_PFCost" (ngModelChange)="calculateVal()" (keydown)="appService.onKeydown($event)" (keydown)="appService.onKeydown($event)" (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99">
              <mat-error *ngIf="formGroupErrors.CostsPF.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.CostsPF.max">{{translations.msgInvalidCostPF}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CostsPF.min">{{translations.msgInvalidCostPF}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_V_CHFCost}}" type="number" formControlName="CostsCHF" 
              [(ngModel)]="parent.order.F_V_CHFCost" (ngModelChange)="calculateVal()" (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99">
              <mat-error *ngIf="formGroupErrors.CostsCHF.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.CostsCHF.max">{{translations.msgInvalidCostCHF}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CostsCHF.min">{{translations.msgInvalidCostCHF}}</mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_V_EuroCHF}}" type="number" formControlName="CostsEURCHF" 
              [(ngModel)]="parent.order.F_V_EuroCHF" (ngModelChange)="calculateVal()"  (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99.99999">
              <mat-error *ngIf="formGroupErrors.CostsEURCHF.pattern">
                  {{translations.msg5Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.CostsEURCHF.max">{{translations.msgInvalidRate}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CostsEURCHF.min">{{translations.msgInvalidRate}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_V_DocumentCost}}" type="number" formControlName="Documentcosts" 
              [(ngModel)]="parent.order.F_V_DocumentCost" (ngModelChange)="calculateVal()"  (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99">
              <mat-error *ngIf="formGroupErrors.Documentcosts.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.Documentcosts.max">{{translations.msgInvalidDocumentCost}}</mat-error>
              <mat-error *ngIf="formGroupErrors.Documentcosts.min">{{translations.msgInvalidDocumentCost}}</mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtCostsVector}}" type="number" formControlName="CostVectors" [(ngModel)]="vectorCostVal" readonly>
              <mat-error *ngIf="formGroupErrors.CostVectors.min">{{translations.msgInvalidCostVector}}</mat-error>
              <mat-error *ngIf="formGroupErrors.CostVectors.max">{{translations.msgInvalidCostVector}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_DistributorCost}}" type="number" formControlName="Distributorcosts" 
              [(ngModel)]="parent.order.F_DistributorCost" (ngModelChange)="calculateVal()" (keypress)="appService.onlyPositiveNumber($event)" min="0" max="99999.99">
              <mat-error *ngIf="formGroupErrors.Distributorcosts.pattern">
                  {{translations.msg2Decimal}}
              </mat-error>
              <mat-error *ngIf="formGroupErrors.Distributorcosts.max">{{translations.msgInvalidDistributorCost}}</mat-error>
              <mat-error *ngIf="formGroupErrors.Distributorcosts.min">{{translations.msgInvalidDistributorCost}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtTotalcosts}}" type="number" formControlName="Totalcosts" [(ngModel)]="totalCost" readonly>
              <mat-error *ngIf="formGroupErrors.Totalcosts.min">{{translations.msgInvalidTotalCost}}</mat-error>
              <mat-error *ngIf="formGroupErrors.Totalcosts.max">{{translations.msgInvalidTotalCost}}</mat-error>
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtRevenue}}" type="number" formControlName="Revenue" [(ngModel)]="revenue" [style.color]="revenue.toString().indexOf('-') > -1 ? 'red' : ''" readonly>
              <mat-error *ngIf="formGroupErrors.Revenue.min">{{translations.msgInvalidRevenu}}</mat-error>	
              <mat-error *ngIf="formGroupErrors.Revenue.max">{{translations.msgInvalidRevenu}}</mat-error>
          </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput placeholder="{{translations.txtF_HantracoInvoiceNo}}" formControlName="InvoicenumberHantraco" [(ngModel)]="parent.order.F_HantracoInvoiceNo" maxlength="25">
          </mat-form-field>
          <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
              <input matInput [matDatepicker]="dp3" placeholder="{{translations.txtF_PaymentDate}}" formControlName="PaymentdatetoSSperLB" [(ngModel)]="parent.order.F_PaymentDate" readonly>
              <mat-icon *ngIf="parent.order.F_PaymentDate" matSuffix (click)="parent.order.F_PaymentDate = ''" style="font-size: 15px;cursor: pointer;">close</mat-icon>
              <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
              <mat-datepicker #dp3 disabled="false"></mat-datepicker>
          </mat-form-field>
      </div>
  </form>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-edit-form/financial-detail/financial-detail.component.html